<template>
    <b-tabs v-if="export_id">
        <b-tab title="Imports" active>
            <ResultImportServerTable :export_id="export_id" />
        </b-tab>
    </b-tabs>
</template>
<script>
import ResultImportServerTable from './ResultImportServerTable.vue';

export default {
    name: "ResultImportCardstack",
    components: { ResultImportServerTable },
    props: {
        export_id: {
            type: String,
            default: null
        }
    }
};
</script>